module.exports = __webpack_public_path__ + "img/new-logo.62ae0895.svg";